const operatorsDefinitions = {
  string: [
    {
      alias: 'is',
      operator: '='
    },
    {
      alias: 'is not',
      operator: '<>',
    },
    {
      alias: 'starts with',
      operator: 'LIKE',
      suffix: '%'
    },
    {
      alias: 'ends with',
      operator: 'LIKE',
      prefix: '%'
    },
    {
      alias: 'contains',
      operator: 'LIKE',
      prefix: '%',
      suffix: '%'
    },
    {
      alias: 'does not contain',
      operator: 'NOT LIKE',
      prefix: '%',
      suffix: '%'
    },
    {
      alias: 'is null',
      operator: 'IS NULL',
      omitValue: true
    },
    {
      alias: 'is not null',
      operator: 'IS NOT NULL',
      omitValue: true
    },
    {
      alias: 'nonop',
      operator: '',
      omitValue: true
    },
  ],
  limitedString: [
    {
      alias: 'contains',
      operator: 'LIKE',
      prefix: '%',
      suffix: '%'
    },
    {
      alias: 'does not contain',
      operator: 'NOT LIKE',
      prefix: '%',
      suffix: '%'
    }
  ],
  number: [
    {
      alias: 'is',
      operator: '='
    },
    {
      alias: 'is not',
      operator: '<>',
    },
    {
      alias: 'is at least',
      operator: '>=',
    },
    {
      alias: 'is less than',
      operator: '<',
    },
    {
      alias: 'is at most',
      operator: '<=',
    },
    {
      alias: 'is greater than',
      operator: '>',
    },
    {
      alias: 'is null',
      operator: 'IS NULL',
      omitValue: true
    },
    {
      alias: 'is not null',
      operator: 'IS NOT NULL',
      omitValue: true
    }
  ],
  date: [
    {
      alias: 'is on',
      fullDay: true,
      operator: 'BETWEEN'
    },
    {
      alias: 'is not on',
      fullDay: true,
      operator: 'NOT BETWEEN'
    },
    {
      alias: 'is before',
      fullDay: true,
      operator: '<',
    },
    {
      alias: 'is after',
      fullDay: true,
      operator: '>',
    },
    {
      alias: 'is on or before',
      operator: '<=',
    },
    {
      alias: 'is on or after',
      operator: '>=',
    },
    {
      alias: 'is null',
      operator: 'IS NULL',
      omitValue: true
    },
    {
      alias: 'is not null',
      operator: 'IS NOT NULL',
      omitValue: true
    },
    {
      alias: 'in the last',
      operator: 'BETWEEN',
      relativeDate: true
    },
    {
      alias: 'not in the last',
      operator: 'NOT BETWEEN',
      relativeDate: true
    }
  ],
  epoch: [
    {
      alias: 'is on',
      fullDay: true,
      operator: 'BETWEEN'
    },
    {
      alias: 'is not on',
      fullDay: true,
      operator: 'NOT BETWEEN'
    },
    {
      alias: 'is before',
      operator: '<',
    },
    {
      alias: 'is after',
      operator: '>',
    },
    {
      alias: 'is on or before',
      operator: '<=',
    },
    {
      alias: 'is on or after',
      operator: '>=',
    },
    {
      alias: 'is null',
      operator: 'IS NULL',
      omitValue: true
    },
    {
      alias: 'is not null',
      operator: 'IS NOT NULL',
      omitValue: true
    }
  ]
};

export default operatorsDefinitions;
